import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { Header } from '../components/layout/Header';

export function Recuperar() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const cleanEmail = email.trim().toLowerCase();
        if (!cleanEmail) {
            setError('Ingresá tu email.');
            return;
        }

        setLoading(true);
        try {
            const res = await api.requestReset(cleanEmail);
            if (res.data?.success) {
                setSent(true);
                setEmail('');
            } else {
                setError(res.data?.error || 'No se pudo procesar la solicitud.');
            }
        } catch (err) {
            const apiError = err.response?.data?.error;
            setError(apiError || 'Error de conexión. Intentá nuevamente.');
        } finally {
            setLoading(false);
        }
    };

    return (<>
        <Header />
        <br />

        <main className="min-h-screen bg-sp-light flex items-center justify-center px-4 xs:px-5 py-8">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="w-full max-w-[400px]">
                <div className="bg-white rounded-3xl p-6 xs:p-8 shadow-sp">
                    <div className="text-center mb-6 xs:mb-8">
                        <div className="w-14 h-14 xs:w-16 xs:h-16 bg-gradient-to-br from-sp-primary to-sp-accent rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                            <Mail className="text-white w-7 h-7 xs:w-8 xs:h-8" />
                        </div>
                        <h1 className="text-[1.4rem] xs:text-[1.6rem] font-black text-sp-text mb-1">Recuperar contraseña</h1>
                        <p className="text-sp-muted text-[0.85rem] xs:text-[0.9rem] font-semibold">Te enviamos un enlace a tu email</p>
                    </div>

                    {sent ? (
                        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-4">
                            <CheckCircle className="w-12 h-12 text-sp-cta mx-auto mb-3" />
                            <p className="text-sp-text font-bold text-[0.95rem] mb-1">¡Email enviado!</p>
                            <p className="text-sp-body text-[0.85rem] font-semibold mb-4">Si el email está registrado, recibirás un enlace en tu casilla.</p>
                            <Link to="/login" className="inline-block w-full h-11 bg-sp-primary text-white rounded-5xl font-extrabold text-[0.95rem] leading-[44px] shadow-cta">
                                Volver al login
                            </Link>
                        </motion.div>
                    ) : (
                        <>
                            {error && (
                                <div className="bg-red-50 border border-red-200 text-red-600 text-[0.85rem] font-semibold px-4 py-3 rounded-xl mb-4 flex items-center gap-2">
                                    <span>⚠️</span> {error}
                                </div>
                            )}

                            <form onSubmit={handleSubmit} className="space-y-4" noValidate>
                                <div>
                                    <label className="block text-[0.8rem] xs:text-[0.85rem] font-extrabold text-sp-text mb-1.5">Email</label>
                                    <div className="relative">
                                        <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 text-sp-primary/50 w-4 h-4 xs:w-5 xs:h-5" />
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="tumail@ejemplo.com"
                                            disabled={loading}
                                            className="w-full h-11 xs:h-12 pl-10 xs:pl-11 pr-4 rounded-xl border-2 border-sp-light bg-sp-light/50 text-sp-text text-[0.9rem] xs:text-base font-semibold placeholder:text-sp-muted/50 focus:outline-none focus:border-sp-primary focus:bg-white transition-all disabled:opacity-50"
                                        />
                                    </div>
                                </div>

                                <button type="submit" disabled={loading} className="w-full h-11 xs:h-12 bg-sp-primary text-white rounded-5xl font-extrabold text-[0.95rem] xs:text-base shadow-cta hover:shadow-cta-hover hover:-translate-y-0.5 active:scale-[0.98] transition-all disabled:opacity-60">
                                    {loading ? 'Enviando...' : 'Enviar enlace'}
                                </button>
                            </form>
                        </>
                    )}

                    <div className="text-center mt-5">
                        <Link to="/login" className="inline-flex items-center gap-1.5 text-[0.8rem] xs:text-[0.85rem] font-bold text-sp-muted hover:text-sp-primary transition-colors">
                            <ArrowLeft className="w-3.5 h-3.5" /> Volver al login
                        </Link>
                    </div>
                </div>
            </motion.div>
        </main>
    </>
    );
}